export default {
  getters: {
    getNameBreadcrumb: state => state.currentBreadcrumb.name
  },
  mutations: {
    setNameBreadcrumb(state, value) {
      state.currentBreadcrumb.name = value
    }
  },
  state: {
    currentBreadcrumb: { name: ''}
  }
}
